<template>
  <div class="cancel-notice">
    <span :class="['icon', 'icon-clock']" />
    <span class="name">
      <template v-if="start">
        <span class="minutes">
          {{ minutes }}
        </span>
        <slot />
      </template>
      <template v-else>
        <slot />
        <span class="minutes">
          {{ minutes }}
        </span>
      </template>
    </span>
  </div>
</template>

<script>
export default {
  name: 'CancelNotice',
  props: {
    minutes: {
      type: Number,
      required: false,
      default: 0,
    },
    start: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .icon {
    width: 12px;
    height: 14px;
    display: inline-block;
    position: absolute;
    left: -12px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }


  .cancel-notice {
    display: inline-block;
    border-radius: 4px;
    font-size: 11px;
    line-height: 14px;
    color: #444;
    position: relative;
    height: 18px;
    text-align: left;
    border-left: 13px solid transparent;
    white-space: nowrap;
    @media screen and (min-width: $desktop-width) {
      font-size: 12px;
      line-height: 1.33;
    }
  }

  .icon-clock {
    background-image: url('../../../assets/svg/icon_clock.svg');
  }

  .name {
    padding: 0 5px;
  }

  .minutes {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.14;
    color: #444;
  }
</style>
